import { Button } from "./button";

export class DropdownButton extends Button {
	parsedCallback() {
		const dropdown = this.querySelector("chip-dropdown");

		if (dropdown) {
			if (!dropdown?.hasAttribute("icon")) { dropdown.icon = this.icon; }
			if (!dropdown?.hasAttribute("suffix-icon")) { dropdown.suffixIcon = this.suffixIcon; }
			if (!dropdown?.hasAttribute("size")) { dropdown.size = this.size; }
			if (!dropdown?.hasAttribute("description")) { dropdown.description = this.description; }
		}
	}
}